import {
  NOTIFY_SUBSCRIBE_STORAGE_KEY,
  NOTIFY_SUBSCRIBE_TICKS_COUNT,
} from 'store/common/notify/constants';

export const subscribeSessionCheck = () => {
  const storage = (window || {}).localStorage;
  let showSubscribe = true;
  if (storage) {
    const { currentCount } = JSON.parse(storage.getItem(NOTIFY_SUBSCRIBE_STORAGE_KEY)) || {};
    if (currentCount !== 0) {
      storage.setItem(
        NOTIFY_SUBSCRIBE_STORAGE_KEY,
        JSON.stringify({
          currentCount: currentCount ? currentCount - 1 : NOTIFY_SUBSCRIBE_TICKS_COUNT,
        }),
      );
    } else if (currentCount === 0) {
      showSubscribe = false;
    }
  }
  // Убрать попап из страниц с утм метками с яндекса
  const locationHref = ((window || {}).location || {}).href || '';
  if (locationHref.indexOf('yandexmarket') !== -1) {
    showSubscribe = false;
  }

  return showSubscribe;
};

export const stopCounter = () => {
  const storage = (window || {}).localStorage;
  if (storage) {
    storage.setItem(
      NOTIFY_SUBSCRIBE_STORAGE_KEY,
      JSON.stringify({
        currentCount: 0,
      }),
    );
  }
};
